/**
 * @fileOverView
 * @description Footer View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var FooterTemplate = require('../../templates/widgets/footer.html');
var AmpersandView = require('ampersand-view');
var app = require('ampersand-app');

var FooterView = AmpersandView.extend({

    template : FooterTemplate,

    initialize: function() {
        // Check if hostname contains "developer" to show dev button
        this.showDeveloperButton = window.location.hostname.includes('developer');
    },

    render: function() {
        this.renderWithTemplate();
        
        // Hide developer button if not on developer hostname
        if (!this.showDeveloperButton) {
            var devButton = this.query('#developer');
            if (devButton) {
                devButton.style.display = 'none';
            }
            // Adjust column widths for remaining 4 buttons
            var navButtons = this.queryAll('.vfnav');
            navButtons.forEach(function(button) {
                if (button.id !== 'developer') {
                    button.style.width = '25%';
                }
            });
        }
        
        return this;
    },

    events: {
        "click #home": "homePage",
        "click #vyblist": "vybListPage",
        "click #logs": "logsPage",
        "click #sounds": "soundsPage",
        "click #developer": "developerPage",
        "click #profile": "profilePage"
    },

    homePage: function(){
        var view =   new app.MainPageView();
        app.pageSwitcher.set(view);
    },

    vybListPage: function(){
        app.pageSwitcher.set(app.vybListPageView);
    },

    logsPage: function(){
        app.pageSwitcher.set(app.logPageView);
    },

    soundsPage: function(){
        app.vyb = null;
        app.pageSwitcher.set(app.soundsPageView);
    },

    developerPage: function(){
        app.pageSwitcher.set(app.developerPageView);
    },
    
    profilePage: function(){
        app.pageSwitcher.set(app.profilePageView);
    }

});

module.exports = FooterView;
